import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import * as Styled from './styles';

export const Referrers = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);

  return (
    <FlexContainer direction="column" fullWidth gap="dimension_16">
      <Text type="paragraphs" color="grey" size="XS_L_M" align="center">
        {t('Referrers.info')}
      </Text>
      <Styled.ReferrersContainers direction="column" gap="dimension_08">
        <Text type="paragraphs" color="dark" size="M_L_S" align="center">
          {t('Referrers.title')}
        </Text>
        <Text type="paragraphs" color="dark" size="S_S_S" align="center">
          {t('Referrers.subtitle')}
        </Text>
        <FlexContainer align="center" justify="space-between">
          <FlexContainer align="center" gap="dimension_16">
            <img
              src={`${TAXDOWN_ASSETS_DOMAIN}/icons/svg/general/medal_gold.svg`}
              alt="gold_medal"
            />
            <Text type="paragraphs" color="dark" size="M_M_S">
              {t('Referrers.name.first')}
            </Text>
          </FlexContainer>
          <Text type="paragraphs" color="fresh" size="L_L_S">
            {t('Referrers.name.first.amount')}
          </Text>
        </FlexContainer>
        <FlexContainer align="center" justify="space-between">
          <FlexContainer align="center" gap="dimension_16">
            <img
              src={`${TAXDOWN_ASSETS_DOMAIN}/icons/svg/general/medal_silver.svg`}
              alt="silver_medal"
            />
            <Text type="paragraphs" color="dark" size="M_M_S">
              {t('Referrers.name.two')}
            </Text>
          </FlexContainer>
          <Text type="paragraphs" color="fresh" size="L_L_S">
            {t('Referrers.name.two.amount')}
          </Text>
        </FlexContainer>
        <FlexContainer align="center" justify="space-between">
          <FlexContainer align="center" gap="dimension_16">
            <img
              src={`${TAXDOWN_ASSETS_DOMAIN}/icons/svg/general/medal_bronze.svg`}
              alt="bronze_medal"
            />
            <Text type="paragraphs" color="dark" size="M_M_S">
              {t('Referrers.name.three')}
            </Text>
          </FlexContainer>
          <Text type="paragraphs" color="fresh" size="L_L_S">
            {t('Referrers.name.three.amount')}
          </Text>
        </FlexContainer>
      </Styled.ReferrersContainers>
    </FlexContainer>
  );
};

export default Referrers;
